<header id="site-header" class="site-header container-fluid" [style.background-color]="topBarColor"
  [class.mobile-info-visible]="mobileInfoVisible" [class.mobile-info-collapsed]="!mobileInfoVisible">

  <div class="row no-gutters mt-1">

    <div class="d-lg-none col-1 order-1 header-toggler-col">
      <button class="navbar-toggler btn-dropdown p-0" type="button" data-toggle="collapse"
        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
        aria-expanded="false" aria-label="Apri menu">
        <em class="fa fa-bars"></em>
      </button>
    </div>

    <div class="col-1 col-lg-2 h-line order-2 header-logo-col">
      <img [src]="logoTourOperator" class="logo img-fluid float-right mr-1 mr-md-3"
        alt="logoEminds">
    </div>

    <div class="col-6 pl-2 order-3 ml-auto ml-lg-0 agency-info"
      [class.d-block]="mobileInfoVisible" [class.d-none]="!mobileInfoVisible" [class.d-lg-block]="!mobileInfoVisible">
      <app-agency-info containerId="container-logoadv" [iter]="iter" [lastUpdate]="lastUpdate" [logoAdv]="logoAdv"
        [consolidator]="consolidator" [isTravelAgency]="isTravelAgency"></app-agency-info>
    </div>

    <div class="col-3 order-4 header-lang-col" *ngIf="selectLanguageView">
      <!-- mobile -->
      <div ngbDropdown class="d-inline d-lg-none" container="body">
        <button id="dropdownMobile" class="btn-dropdown btn p-0 mr-2 float-right" ngbDropdownToggle>
          <em class="fa fa-cogs">&nbsp;</em>
        </button>

        <div ngbDropdownMenu aria-labelledby="dropdownMobile" class="p-3">
          <app-language-switcher class = "d-block mt-1"></app-language-switcher>
        </div>
      </div>

      <app-language-switcher class="d-none d-lg-block btn-options float-right"></app-language-switcher>
    </div>

  </div>

  <hr>
</header>
